import { RenderBlock } from '@rst/render-blocks/src/types'
import { SUPPORTED_LANGS, isDevelopment } from '@rst/libs-ts'
import { Store } from 'effector'

export const initL10N = ($store: Store<RenderBlock.Init>) => {
	const $langSetting: Store<
		RenderBlock.Init['lang_setting'] & { availableLangs: string[] }
	> = $store.map(x =>
		x?.lang_setting
			? {
					...x.lang_setting,
					type: isDevelopment ? 'path' : x.lang_setting.type,
					availableLangs: getAvailableLangs(x?.languages),
			  }
			: {
					type: 'path',
					select: 'full',
					select_pos: 'header-footer',
					availableLangs: getAvailableLangs(x?.languages),
			  }
	)

	return { $langSetting }
}

const getAvailableLangs = (languages?: string[]) => {
	if (languages?.length) {
		return languages.filter(
			code =>
				SUPPORTED_LANGS.hasOwnProperty(code) &&
				!SUPPORTED_LANGS[code].props?.beta
		)
	}

	return ['ru']
}
